import {createFileRoute, Outlet} from '@tanstack/react-router'

export const Route = createFileRoute('/_app/quotes/$quoteId')({
    component: QuoteIdLayout,
})

function QuoteIdLayout() {
    return <Outlet />
}
